"use strict";

module.exports = Object.freeze({
  CREATE: 'CREATE',
  CONTINUE: 'CONTINUE',
  CANCEL: 'CANCEL'
});